<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Maria Baldwin’s Worlds</h1>
<h1 class="bk1">A Story of Black New England and the Fight for Racial Justice</h1>
<p class="bkau">Kathleen Weiler</p>
<p class="bkpub"><a class="page" data-locator="piii"></a>University of Massachusetts Press</p>
<p class="bkpub1">Amherst &amp; Boston</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Weiler0004.vue?168cc60e